import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LTileLayer = _resolveComponent("LTileLayer")!

  return (_openBlock(), _createBlock(_component_LTileLayer, {
    url: _ctx.url,
    attribution: _ctx.attribution,
    visible: _ctx.visible,
    options: {maxNativeZoom: 19, maxZoom: 21},
    key: "basic",
    name: "Základní",
    "layer-type": "base"
  }, null, 8, ["url", "attribution", "visible"]))
}